import { useEffect, useState } from 'react';
import {
  Card,
  Box,
  MenuItem,
  Divider,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  Tooltip,
  IconButton,
  useTheme,
  Button,
  TextField,
  InputAdornment,
  CircularProgress,
  DialogTitle,
  styled,
  Dialog,
  DialogContent
} from '@mui/material';
import React, { useContext } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import Filter from 'src/content/applications/Users/common/filter';
import CopyAllTwoTone from '@mui/icons-material/CopyAllTwoTone';
import { ManagementServices } from 'src/services/ManagementServices';
import Swal from 'sweetalert2';
import { CategoryDetails } from 'src/models/Category';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './../ToastStyle.css';
import moment from 'moment';
import SearchIcon from '@mui/icons-material/Search';
import { InventoryService } from 'src/services/InventoryService';
import { Link } from 'react-router-dom';
import EditShop from '../Users/shopProfile/EditShopPopUp';
import EditPaymentTypePopUp from '../Users/shopProfile/EditPaymentType';
import EditShopNote from '../Users/shopProfile/EditShopNote';
import ImportCSV from './ImportCSV';
import ImportShopInventoryTemplate from './ImportShopInventoryTemplate';
import { CreateShop } from './create-shop-popup';
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import UserDetails from './UserDetails';
import AdminInvoice from './AdminInvoice/AdminInvoice';
import AdminCustomer from './AdminCustomers/AdminCustomer';
import AdminInventory from './AdminInventory/AdminInventory';
import DeletePopUp from './DeletePopUP';
import PaymentStatusBox from './PaymentStatusBox';
import UserContext from 'src/context/UserContext';
import { Role } from 'src/Role';
import PaymentIcon from '@mui/icons-material/Payment';
import { usePlanCatalog } from 'src/features/billing/usePlanCatalog';
import SmsIcon from '@mui/icons-material/Sms';
import { set } from 'date-fns';
import TopUpSmsDialog from '../Users/shopProfile/TopupSMSAmount';
import {
  pageCardSx,
  pageToolbarSx
} from 'src/theme/contentStyles';

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 5 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

const stickyActionCellSx = {
  position: 'sticky',
  right: 0,
  zIndex: 3,
  minWidth: 128,
  whiteSpace: 'nowrap',
  backgroundColor: 'background.paper',
  boxShadow: '-8px 0 10px -8px rgba(15, 23, 42, 0.18)',
  'thead &': {
    zIndex: 4,
    backgroundColor: 'background.paper'
  },
  'tr:hover > &': {
    backgroundColor: 'action.hover'
  }
} as const;

const hasAdditionalBranches = (shop: any) => Number(shop?.branchCount) > 2;

const formatDealerCode = (dealerCode?: string) => {
  if (typeof dealerCode !== 'string') {
    return '-';
  }
  const code = dealerCode.trim();
  // Valid only when stored value has RF prefix plus an actual code (e.g. RF6572)
  if (!/^RF.+/i.test(code)) {
    return '-';
  }
  return dealerCode;
};

const AllShopsTable = ({ }) => {
  const { planName, planHasFeature } = usePlanCatalog();
  const [billedValue, setBilledValue] = useState<any>('All');
  const [trialEnd, setTrialEnd] = useState<any>('');
  const [value, setValue] = useState<any>('All');
  const [startValue, setStartValue] = useState(null);
  const [endValue, setEndValue] = useState(null);
  const [showCustomDatePicker, setShowCustomDatePicker] = useState(false);
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState<number>(0);
  const [limit, setLimit] = useState<number>(10);
  const [allShops, setAllShops] = useState<any[]>([]);
  const [shopId, setId] = useState();
  const [openEdit, setOpenEdit] = useState(false);
  const [openPaymentEdit, setOpenPaymentEdit] = useState(false);
  const [openNoteEdit, setOpenNoteEdit] = useState(false);
  const [openSmsTopupEdit, setOpenSmsTopupEdit] = useState(false);
  const [openCSV, setOpenCSV] = useState(false);
  const [openUserDetails, SetOpenUserDetails] = useState(false);
  const [openeDeletePopUp, setOpenDeletePopUp] = useState(false);
  const [openTemplate, setOpenTemplate] = useState(false);
  const [selectedShopId, setSelectedShopId] = useState();
  const [selectedShopIdD, setSelectedShopIdD] = useState();
  const [selectedShopIndexD, setSelectedShopIndexD] = useState();
  const [selectedShopUserId, setSelectedShopUserId] = useState();
  const [searchKeyword, setSearchKeyword] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [currentSearchTerm, setCurrentSearchTerm] = useState('');
  const [AllCategories, setAllCategories] = useState([] as CategoryDetails[]);
  const [loading, setLoading] = useState(false);
  const [ifSearchChanged, setIfSearchChanged] = useState(false);
  const [currentPageComponents, setCurrentPageComponents] = useState<number>(0);
  const [editIndex, setEditIndex] = useState(null);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [openPreview, setOpenPreview] = useState(false);
  const [selectedShopNote, setSelectedShopNote] = useState<any[]>([]);
  const [selectedShop, setSelectedShop] = useState<any>(null);
  const [selectedSmsLenzSenderID, setSelectedSmsLenzSenderID] = useState('');
  const [user] = useContext(UserContext);
  const [showOrderDropdown, setShowOrderDropdown] = React.useState(false);
  const [sortOrder, setSortOrder] = React.useState('desc');

  useEffect(() => {
    getAllShops();
    setCurrentDate(new Date());
    console.log('useriddddd', user?._id);
  }, [currentSearchTerm, page, limit, startValue, endValue, billedValue, sortOrder, trialEnd]);

  const getAllShops = async () => {
    try {
      const params = new URLSearchParams({
        search: currentSearchTerm,
        startDate: startValue,
        endDate: endValue,
        page: (page + 1).toString(),
        limit: limit.toString(),
        paymentStatus: billedValue,
        sortBy: billedValue === 'TRIAL' ? 'invoiceCount' : '',
        sortOrder: billedValue === 'TRIAL' ? sortOrder : '',
        trialEnd: trialEnd
      });
      const res = await InventoryService.getAllShops(params.toString());

      if (res.success) {
        if (ifSearchChanged) {
          const shops = res.data.shops || [];

          setAllShops(shops);
        } else {
          const shops = res.data.shops || [];
          setAllShops((prevList) => [...prevList, ...shops]);
        }
        setIfSearchChanged(false);
        setLoading(false);
      } else {
        toast.error('Failed to fetch shops');
      }
    } catch (error) {
      console.error('Error fetching shops:', error);
      toast.error('An error occurred while fetching shops');
    } finally {
      setIsLoading(false);
    }
  };

  const handlePageChange = (event: any, newPage: number): void => {
    setLoading(true);
    setPage(newPage);
  };
  const theme = useTheme();

  const handleEditOpen = (index: any, shopID: any, userID: any) => {
    setSelectedShopId(shopID);
    setSelectedShopUserId(userID);
    setOpenEdit(true);
    setEditIndex(index);
  };

  const handleSmsTopupOpen = (index: any, shopID: any, userID: any, shop?: any) => {
    setSelectedShopUserId(userID);
    setSelectedShop(shop || null);
    setSelectedSmsLenzSenderID(
      shop?.smsLenzSenderID || shop?.smsLenzSenderId || ''
    );
    setEditIndex(index);
    setOpenSmsTopupEdit(true);
  };

  const handleSmsTopupEditClose = () => {
    setOpenSmsTopupEdit(false);
    setSelectedSmsLenzSenderID('');
  };

  const handleSmsTopupSuccess = (senderId: string) => {
    if (editIndex == null) return;
    const updatedShops = [...allShops];
    if (updatedShops[editIndex]) {
      updatedShops[editIndex] = {
        ...updatedShops[editIndex],
        smsLenzSenderID: senderId
      };
      setAllShops(updatedShops);
      setSelectedSmsLenzSenderID(senderId);
      setSelectedShop(updatedShops[editIndex]);
    }
  };


  const handlePaymentEditOpen = (index: any, shop: any, shopID: any, userID: any) => {
    setSelectedShopId(shopID);
    setSelectedShopUserId(userID);
    setSelectedShop(shop ? { ...shop } : null);
    setOpenPaymentEdit(true);
    setEditIndex(index);
  };
  const handleNoteEditOpen = (index: any, shop: any) => {
    setSelectedShopId(shop?._id);
    setSelectedShopUserId(shop?.createdBy);
    setSelectedShopNote(shop?.shopNote);
    setOpenNoteEdit(true);
    setEditIndex(index);
  };
  const handleEditClose = () => {
    setOpenEdit(false);
  };
  const handlePaymentEditClose = () => {
    setOpenPaymentEdit(false);
    setSelectedShop(null);
  };
  const handleNoteEditClose = () => {
    setOpenNoteEdit(false);
  };
  const handleCSVOpen = (shopID: any) => {
    setSelectedShopId(shopID);
    setOpenCSV(true);
  };
  const handleCSVClose = () => {
    setOpenCSV(false);
  };
  const handleUserDetailsOpen = (shopID: any) => {
    setSelectedShopId(shopID);
    SetOpenUserDetails(true);
  };

  const handleUserDetailsClose = () => {
    SetOpenUserDetails(false);
  };

  const handleTemplateOpen = (shopID: any, index: any) => {
    setSelectedShopId(shopID);
    setOpenTemplate(true);
    setEditIndex(index);
  };

  const handleTemplateClose = () => {
    setOpenTemplate(false);
  };

  const handleSearchChange = () => {
    setIsLoading(true);
    setOpen(false);
    setIfSearchChanged(true);
    setPage(0);
  };

  const handleSearch = () => {
    setIsLoading(true);
    setCurrentSearchTerm(searchKeyword);
    setIfSearchChanged(true);
    setPage(0);
  };
  const handleSearchClear = () => {
    setIsLoading(true);
    setIfSearchChanged(true);
    setSearchKeyword('');
    setCurrentSearchTerm('');
    setPage(0);
  };
  const handleDeletePopUpOpen = (shopID: any, index: any) => {
    setSelectedShopIdD(shopID);
    setSelectedShopIndexD(index);
    setOpenDeletePopUp(true);
  };
  const handleDeletePopUpClose = (index: any) => {
    setOpenDeletePopUp(false);
  };
  const handleCopy = async (shopId) => {
    await navigator.clipboard.writeText(shopId);
    toast('Copied to clipboard', {
      style: {
        boxShadow: 'none'
      }
    });
  };
  const deleteConform = (deleteOption: string) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085D6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'OK',
      cancelButtonText: 'Close'
    }).then((result) => {
      if (result.isConfirmed) {
        ManagementServices.deleteShop(selectedShopIdD, deleteOption)
          .then((res) => {
            Swal.fire('Deleted!', 'Shop has been deleted.', 'success').then(
              (result) => {
                if (result.isConfirmed) {
                  const deleteShop = [...allShops];
                  deleteShop.splice(selectedShopIndexD, 1);
                  setAllShops(deleteShop);
                }
              }
            );
          })
          .catch((error) => {
            Swal.fire(
              'Error!',
              'There was an error deleting your file.',
              'error'
            );
          });
      }
    });
  };
  const handelBilledAmout = (value: any) => {
    setIsLoading(true);
    setBilledValue(value);
    setIfSearchChanged(true);
    setPage(0);
  };
  const handelPaymentStatus = (value: any) => {
    setIsLoading(true);
    setShowOrderDropdown(value === 'TRIAL');
    setBilledValue(value);
    setIfSearchChanged(true);
    setPage(0);
  };
  const handleTrialEnd = (value: any) => {
    setIsLoading(true);
    setTrialEnd(value);
    setIfSearchChanged(true);
    setPage(0);
  };
  const handelSortingOrder = (value: any) => {
    setIsLoading(true);
    setSortOrder(value)
    setIfSearchChanged(true);
    setPage(0);
  };

  const handleChange = (event: any) => {
    const selectedvalue = event.target.value;
    const today = new Date();
    setIsLoading(true);
    setValue(selectedvalue);
    setOpen(false);
    setIfSearchChanged(true);
    setPage(0);
    switch (selectedvalue) {
      case 'Today':
        const todayDateBefore = new Date(today);
        todayDateBefore.setDate(today.getDate() - 1);
        setStartValue(todayDateBefore);
        setEndValue(new Date());
        setShowCustomDatePicker(false);
        break;
      case 'Last 7 days':
        const sevenDaysAgo = new Date(today);
        sevenDaysAgo.setDate(today.getDate() - 6);
        setEndValue(today);
        setStartValue(sevenDaysAgo);
        setShowCustomDatePicker(false);
        break;
      case 'Last 28 days':
        const twentyEightDaysAgo = new Date(today);
        twentyEightDaysAgo.setDate(today.getDate() - 27);
        setEndValue(today);
        setStartValue(twentyEightDaysAgo);
        setShowCustomDatePicker(false);
        break;
      case 'Custom':
        setStartValue(null);
        setEndValue(null);
        setShowCustomDatePicker(true);
        break;
      default:
        setStartValue(null);
        setEndValue(null);
        setShowCustomDatePicker(false);
        break;
    }
  };
  const handleOpen = () => {
    setOpen(true);
  };
  const navigateToProductsPage = (shopId: any) => {
    if (shopId != undefined) {
      setId(shopId);
      setCurrentPageComponents(1);
    }
  };
  const callBackPage = () => {
    setCurrentPageComponents(0);
  };
  const navigateToCustomersPage = (shopId: any) => {
    if (shopId != undefined) {
      setId(shopId);
      setCurrentPageComponents(2);
    }
  };
  const callBackPageCustomer = () => {
    setCurrentPageComponents(0);
  };
  const navigateToInventoryPage = (shopId: any) => {
    if (shopId != undefined) {
      setId(shopId);
      setCurrentPageComponents(3);
    }
  };
  const callBackPageInventory = () => {
    setCurrentPageComponents(0);
  };
  const StyledDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiPaper-root': {
      width: '50vw',
      maxWidth: 'none'
    }
  }));
  const handlePreviewOpen = (shop: any) => {
    setOpenPreview(true);
    setSelectedShopNote(shop?.shopNote);
  };
  const handlePreviewClose = () => {
    setOpenPreview(false);
  };

  const updatePaymentType = async (customerSupport: string, shop: any, index: number) => {
    try {
      setLoading(true);
      // Call API to update payment type
      const res = await InventoryService.updateShoCSType({ customerSupport: customerSupport }, shop?._id);
      if (res.success) {
        toast.success('Customer support name updated successfully');
        setAllShops(prev => {
          const updated = [...prev];
          updated[index] = {
            ...updated[index],
            customerSupport: customerSupport,
          };
          return updated;
        });
      } else {
        toast.error('Failed to update Customer support name');
      }
    } catch (error) {
      toast.error('Error updating Customer support name');
    } finally {
      setLoading(false);
    }
  };

  const showBranchesColumn = allShops.some(hasAdditionalBranches);

  return (
    <>
      <StyledDialog open={openPreview} onClose={handlePreviewClose}>
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handlePreviewClose}
        >
          <Typography variant="h4" fontWeight="bold">
            Shop Note
          </Typography>
        </BootstrapDialogTitle>
        <>
          <Typography
            sx={{
              display: 'inline',
              marginTop: '-20px',
              marginBottom: '10px',
              marginLeft: '50px'
            }}
            component="span"
            variant="body2"
            color="text.primary"
          >
            {selectedShopNote}
          </Typography>
        </>
        <DialogContent></DialogContent>
      </StyledDialog>
      {currentPageComponents == 0 && (
        <Card sx={pageCardSx}>
          <Box sx={pageToolbarSx}>
            <Box
              display="flex"
              sx={{ flexWrap: 'wrap' }}
              alignItems="center"
              gap={1}
            >
              {user?.role != Role.CUSTOMER_SUPPORT && (
                <CreateShop
                  AllCategories={AllCategories}
                  setAllCategories={setAllCategories}
                  allShops={allShops}
                  setAllShops={setAllShops}
                />
              )}
              <Filter
                billedValue={billedValue}
                handelBilledAmout={handelBilledAmout}
                value={value}
                startValue={startValue}
                endValue={endValue}
                showCustomDatePicker={showCustomDatePicker}
                handleChange={handleChange}
                handleOpen={handleOpen}
                setStartValue={setStartValue}
                setEndValue={setEndValue}
                handleSearchChange={handleSearchChange}
                dropDownHeading="Billed Amount"
                open={open}
                maxDate={currentDate}
              />
              <TextField
                select
                variant="outlined"
                label="Payment Status"
                value={billedValue}
                onChange={(event) => {
                  const value = event.target.value;
                  handelPaymentStatus(value);
                }}
                SelectProps={{
                  displayEmpty: true
                }}
                sx={{ minWidth: 100 }}
              >
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="PAID">PAID</MenuItem>
                <MenuItem value="TRIAL">TRIAL</MenuItem>
                <MenuItem value="PENDING">PENDING</MenuItem>
              </TextField>
              <TextField
                select
                variant="outlined"
                label="Trial End in"
                onChange={(event) => {
                  const value = event.target.value;
                  handleTrialEnd(value);
                }}
                SelectProps={{
                  displayEmpty: true
                }}
                sx={{ minWidth: 100 }}
              >
                <MenuItem value="null">
                  <em>Select</em>
                </MenuItem>
                <MenuItem value="today">today</MenuItem>
                <MenuItem value="tomorrow">tomorrow</MenuItem>
                <MenuItem value="week">week</MenuItem>
              </TextField>
              {showOrderDropdown && (
                <TextField
                  select
                  variant="outlined"
                  label="Sort Order"
                  value={sortOrder}
                  onChange={(event) => {
                    handelSortingOrder(event.target.value);
                  }}
                  sx={{ minWidth: 100 }}
                >
                  <MenuItem value="asc">Asc</MenuItem>
                  <MenuItem value="desc">Desc</MenuItem>
                </TextField>
              )}
              <TextField
                size="small"
                variant="outlined"
                placeholder="Search shops..."
                value={searchKeyword}
                onChange={(e) => setSearchKeyword(e.target.value)}
                sx={{
                  minWidth: { xs: '100%', sm: 200 },
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '10px',
                    backgroundColor: 'rgba(90, 115, 255, 0.03)'
                  }
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => handleSearch()}
                        color="primary"
                        size="small"
                      >
                        <SearchIcon />
                      </IconButton>
                      <IconButton
                        onClick={handleSearchClear}
                        color="error"
                        size="small"
                      >
                        <CloseIcon />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </Box>
          </Box>

          {isLoading ? (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="300px"
            >
              <CircularProgress />
            </Box>
          ) : (
            <TableContainer sx={{ overflowX: 'auto' }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>ShopId</TableCell>
                    <TableCell>Shop Name</TableCell>
                    <TableCell>Dealer Code</TableCell>
                    <TableCell>User Email / Contact Number</TableCell>
                    <TableCell>Remaining Days</TableCell>
                    {/* <TableCell>Subscription Plan</TableCell> */}
                    <TableCell>Plan Period</TableCell>
                    {/* <TableCell>payment Type</TableCell> */}
                    <TableCell>Payment Status</TableCell>
                    <TableCell>Previous Plan</TableCell>
                    <TableCell>Created Date</TableCell>
                    <TableCell>Invoice</TableCell>
                    {showBranchesColumn && <TableCell>Branches</TableCell>}
                    <TableCell>Note</TableCell>
                    <TableCell>View Note</TableCell>
                    <TableCell>CS Name</TableCell>
                    <TableCell align="center" sx={stickyActionCellSx}>
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {allShops.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={showBranchesColumn ? 15 : 14} align="center">
                        <Typography variant="body2" color="text.secondary" sx={{ py: 2 }}>
                No data to display
              </Typography>
                      </TableCell>
                    </TableRow>
                  ) : (
                    allShops?.map((shop, index) => {
                      const start = moment();
                      const end = moment(shop.paymentEndDate, 'DD/MM/YYYY');
                      const startDate = moment(
                        shop.paymentStartDate,
                        'DD/MM/YYYY'
                      );
                      const daysRemaining = end.diff(start, 'days');
                      const days = end.diff(startDate, 'days');

                      return (
                        <TableRow hover key={index}>
                          <TableCell>
                            {index + 1}

                            <Tooltip title="Copy ID" arrow>
                              <IconButton
                                onClick={() => handleCopy(shop?._id)}
                                sx={{
                                  '&:hover': {
                                    background: theme.colors.primary.lighter
                                  },
                                  color: theme.palette.warning.main
                                }}
                                color="inherit"
                                size="small"
                              >
                                <CopyAllTwoTone fontSize="small" />
                                <ToastContainer
                                  position="bottom-right"
                                  autoClose={1000}
                                  hideProgressBar
                                  newestOnTop={false}
                                  closeOnClick={false}
                                  rtl={false}
                                  pauseOnFocusLoss={false}
                                  draggable={false}
                                  pauseOnHover={false}
                                  theme="dark"
                                />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                          {user?.role != Role.CUSTOMER_SUPPORT ? (
                            <>
                              <TableCell>
                                <Link
                                  to={`/management/profile/shop-profile?shopId=${shop._id}`}
                                >
                                  <Typography
                                    component="span"
                                    sx={{
                                      cursor: 'pointer',
                                      textDecoration: 'underline',
                                      color: 'primary.main'
                                    }}
                                  >
                                    {shop?.shopName}
                                  </Typography>
                                </Link>
                              </TableCell>
                            </>
                          ) : (
                            <>
                              <TableCell>{shop?.shopName}</TableCell>
                            </>
                          )}

                          <TableCell>
                            {formatDealerCode(shop?.dealerCode)}
                          </TableCell>

                          {user?.role != Role.CUSTOMER_SUPPORT ? (
                            <>
                              <TableCell sx={{ maxWidth: 180, whiteSpace: 'normal' }}>
                                <Box
                                  onClick={() =>
                                    handleUserDetailsOpen(shop?._id)
                                  }
                                  sx={{
                                    cursor:
                                      shop?.userEmail || shop?.userPhoneNumber
                                        ? 'pointer'
                                        : 'default'
                                  }}
                                >
                                  <Typography
                                    component="span"
                                    display="block"
                                    sx={{
                                      fontSize: 13,
                                      lineHeight: 1.35,
                                      wordBreak: 'break-word',
                                      textDecoration:
                                        shop?.userEmail || shop?.userPhoneNumber
                                          ? 'underline'
                                          : 'none',
                                      color:
                                        shop?.userEmail || shop?.userPhoneNumber
                                          ? 'primary.main'
                                          : 'text.primary'
                                    }}
                                  >
                                    {shop?.userEmail
                                      ? shop.userEmail
                                      : shop?.userPhoneNumber || '-'}
                                  </Typography>
                                  <Typography
                                    component="span"
                                    display="block"
                                    sx={{
                                      mt: 0.25,
                                      fontSize: 12.5,
                                      lineHeight: 1.35,
                                      color: 'text.secondary',
                                      wordBreak: 'break-word'
                                    }}
                                  >
                                    {shop?.phoneNumber ? shop.phoneNumber : '-'}
                                  </Typography>
                                </Box>
                              </TableCell>
                            </>
                          ) : (
                            <>
                              <TableCell sx={{ maxWidth: 180, whiteSpace: 'normal' }}>
                                <Typography
                                  component="span"
                                  display="block"
                                  sx={{
                                    fontSize: 13,
                                    lineHeight: 1.35,
                                    wordBreak: 'break-word'
                                  }}
                                >
                                  {shop?.userEmail
                                    ? shop.userEmail
                                    : shop?.userPhoneNumber || '-'}
                                </Typography>
                                <Typography
                                  component="span"
                                  display="block"
                                  sx={{
                                    mt: 0.25,
                                    fontSize: 12.5,
                                    lineHeight: 1.35,
                                    color: 'text.secondary',
                                    wordBreak: 'break-word'
                                  }}
                                >
                                  {shop?.phoneNumber ? shop.phoneNumber : '-'}
                                </Typography>
                              </TableCell>
                            </>
                          )}

                          <TableCell>
                            <span
                              style={{
                                backgroundColor: daysRemaining < 0 ? 'red' : 'transparent',
                                color: daysRemaining < 0 ? 'white' : 'inherit',
                                padding: '2px 6px',
                                borderRadius: '4px',
                              }}
                            >
                              {daysRemaining}
                            </span>
                          </TableCell>

                          <TableCell>
                            {shop?.paymentStartDate} {' - '}{' '}
                            {shop?.paymentEndDate}
                          </TableCell>

                          <TableCell>
                            <PaymentStatusBox
                              status={
                                shop?.premiumStatus != 'REVOKED'
                                  ?
                                  shop?.paymentStatus
                                    ? shop?.paymentStatus == 'PAID'
                                      ? planName(shop?.premiumUserType)
                                      : shop?.paymentStatus == 'REVOKED'
                                        ? 'REVOKED'
                                        : shop?.paymentStatus
                                    : 'N/A'
                                  : 'REVOKED'
                              }
                            />
                          </TableCell>

                          <TableCell>
                            <PaymentStatusBox
                              status={
                                shop?.previousSubscriptionPlan ? planName(shop?.previousSubscriptionPlan)
                                  : 'N/A'
                              }
                              lowFontSize={true}
                            />
                          </TableCell>

                          <TableCell>
                            {moment(shop?.createdAt).format(
                              'MMM Do YYYY, h:mm A'
                            )}
                          </TableCell>
                          {user?.role != Role.CUSTOMER_SUPPORT ? (
                            <>
                              <TableCell>
                                <Button
                                  onClick={() => {
                                    navigateToProductsPage(shop?._id);
                                  }}
                                  variant="outlined"
                                  color="primary"
                                  sx={{
                                    width: '40px',
                                    minWidth: '40px',
                                    borderColor: 'primary.main',
                                    color: 'primary.main',
                                    '&:hover': {
                                      borderColor: 'primary.dark',
                                      color: 'primary.dark'
                                    },
                                    padding: '1px 0px',
                                    mb: 0
                                  }}
                                >
                                  {shop.invoiceCount ?? 'Loading...'}
                                </Button>
                              </TableCell>
                            </>
                          ) : (
                            <>
                              <TableCell>{shop?.invoiceCount}</TableCell>
                            </>
                          )}

                          {showBranchesColumn && (
                            <TableCell>
                              {hasAdditionalBranches(shop)
                                ? shop.branchCount
                                : ''}
                            </TableCell>
                          )}

                          <TableCell align="center">
                            <Tooltip title="Edit shop Note" arrow>
                              <IconButton
                                onClick={() => handleNoteEditOpen(index, shop)}
                                sx={{
                                  '&:hover': {
                                    background: theme.colors.primary.lighter
                                  },
                                  color: theme.palette.primary.main
                                }}
                                color="inherit"
                                size="small"
                              >
                                <EditTwoToneIcon
                                  fontSize="small"
                                  color="inherit"
                                />
                              </IconButton>
                            </Tooltip>
                          </TableCell>

                          <TableCell>{shop?.shopNote ? shop?.shopNote : '-'}</TableCell>
                          <TableCell align="center">
                            <TextField
                              select
                              variant="outlined"
                              size="small"
                              value={shop?.customerSupport || ''}
                              onChange={(e) => { void updatePaymentType(e.target.value, shop, index); }}
                              sx={{ minWidth: 100 }}
                            >
                              <MenuItem value="SELECT">SELECT</MenuItem>
                              <MenuItem value="AKASH">AKASH</MenuItem>
                            </TextField>
                          </TableCell>

                          <TableCell align="center" sx={stickyActionCellSx}>
                            <Tooltip title="Edit shop payment" arrow>
                              <IconButton
                                onClick={() =>
                                  handlePaymentEditOpen(
                                    index,
                                    shop,
                                    shop?._id,
                                    shop?.createdBy
                                  )
                                }
                                sx={{
                                  '&:hover': {
                                    background: theme.colors.primary.lighter
                                  },
                                  color: theme.palette.primary.main
                                }}
                                color="inherit"
                                size="small"
                              >
                                <PaymentIcon
                                  fontSize="small"
                                  color="inherit"
                                />
                              </IconButton>
                            </Tooltip>

                            {user?.role != Role.CUSTOMER_SUPPORT &&
                              planHasFeature(shop?.premiumUserType, 'AUTOMATED_SMS') && (
                              <Tooltip title="Top-up SMS" arrow>
                                <IconButton
                                  onClick={() =>
                                    handleSmsTopupOpen(
                                      index,
                                      shop?._id,
                                      shop?.createdBy,
                                      shop
                                    )
                                  }
                                  sx={{
                                    '&:hover': {
                                      background: theme.colors.primary.lighter
                                    },
                                    color: theme.palette.primary.main
                                  }}
                                  color="inherit"
                                  size="small"
                                >
                                  <SmsIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            )}


                            {user?.role != Role.CUSTOMER_SUPPORT && (
                              <Tooltip title="Edit shop details" arrow>
                                <IconButton
                                  onClick={() =>
                                    handleEditOpen(
                                      index,
                                      shop?._id,
                                      shop?.createdBy
                                    )
                                  }
                                  sx={{
                                    '&:hover': {
                                      background: theme.colors.primary.lighter
                                    },
                                    color: theme.palette.primary.main
                                  }}
                                  color="inherit"
                                  size="small"
                                >
                                  <EditTwoToneIcon
                                    fontSize="small"
                                    color="inherit"
                                  />
                                </IconButton>
                              </Tooltip>
                            )}
                            {user?.role != Role.CUSTOMER_SUPPORT && (
                              <Tooltip title="Delete Shop" arrow>
                                <IconButton
                                  onClick={() =>
                                    handleDeletePopUpOpen(shop?._id, index)
                                  }
                                  sx={{
                                    '&:hover': {
                                      background: theme.colors.primary.lighter
                                    },
                                    color: theme.palette.primary.main
                                  }}
                                  color="inherit"
                                  size="small"
                                >
                                  <DeleteTwoToneIcon
                                    fontSize="small"
                                    color="error"
                                  />
                                </IconButton>
                              </Tooltip>
                            )}
                          </TableCell>

                        </TableRow>
                      );
                    })
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          )}
          {allShops.length === 0 ? (
            <Typography></Typography>
          ) : (
            <Box p={2} display="flex" justifyContent="center">
              {allShops.length >= 10 && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={(e) => handlePageChange(e, page + 1)}
                >
                  {loading ? 'Loading...' : 'See More'}
                </Button>
              )}
            </Box>
          )}
          <EditShop
            open={openEdit}
            onClose={handleEditClose}
            shopId={selectedShopId}
            userId={selectedShopUserId}
            allShops={allShops}
            setAllShops={setAllShops}
            index={editIndex}
          />
          <EditPaymentTypePopUp
            open={openPaymentEdit}
            selectedShop={selectedShop}
            onClose={handlePaymentEditClose}
            userId={selectedShopUserId}
            allShops={allShops}
            setAllShops={setAllShops}
            index={editIndex}
          />
          <EditShopNote
            open={openNoteEdit}
            selectedShopNote={selectedShopNote}
            onClose={handleNoteEditClose}
            shopId={selectedShopId}
            userId={selectedShopUserId}
            allShops={allShops}
            setAllShops={setAllShops}
            index={editIndex}
          />
          <TopUpSmsDialog
            open={openSmsTopupEdit}
            onClose={handleSmsTopupEditClose}
            userId={selectedShopUserId}
            smsLenzSenderID={selectedSmsLenzSenderID}
            onSuccess={handleSmsTopupSuccess}
          />
          <ImportCSV
            open={openCSV}
            onClose={handleCSVClose}
            shopId={selectedShopId}
            get={getAllShops}
          />
          <ImportShopInventoryTemplate
            open={openTemplate}
            onClose={handleTemplateClose}
            shopId={selectedShopId}
            allShops={allShops}
            setAllShops={setAllShops}
            index={editIndex}
          />
          <UserDetails
            open={openUserDetails}
            onClose={handleUserDetailsClose}
            shopId={selectedShopId}
          />
          <DeletePopUp
            open={openeDeletePopUp}
            onClose={handleDeletePopUpClose}
            shopId={selectedShopIdD}
            index={selectedShopIndexD}
            get={deleteConform}
          />
        </Card>
      )}
      {currentPageComponents == 1 && (
        <AdminInvoice callBackPage={() => callBackPage()} shopId={shopId} />
      )}
      {currentPageComponents == 2 && (
        <AdminCustomer
          callBackPage={() => callBackPageCustomer()}
          shopId={shopId}
        />
      )}
      {currentPageComponents == 3 && (
        <AdminInventory
          callBackPage={() => callBackPageInventory()}
          shopId={shopId}
        />
      )}
    </>
  );
};
export default AllShopsTable;
